import { Action, ActionTypes } from './actions';
import { TDevice } from '@cian/utils';

export interface IMobile {
  deviceType?: TDevice;
  isMobileVersion: boolean;
  areFiltersOpened?: boolean;
  filtersCleared: boolean;
}

export const DEFAULT_MOBILE: IMobile = {
  isMobileVersion: false,
  filtersCleared: false,
};

export function mobileReducer(state: IMobile, action: Action): IMobile {
  switch (action.type) {
    case ActionTypes.FiltersOpened:
      return {
        ...state,
        areFiltersOpened: action.opened,
      };

    case ActionTypes.FiltersCleared:
      return {
        ...state,
        filtersCleared: action.cleared,
      };

    default:
      return state || DEFAULT_MOBILE;
  }
}
